import settings from './Settings.json';

export default class Settings {
  public static readonly ownUrl: string = settings.ownUrl.toString();
  public static readonly idUrl: string = settings.idUrl.toString();
  public static readonly domainName: string = settings.domainName.toString();
  public static readonly messageShowDuration: number = 20000;
}
